var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2837 5.55072C14.5672 5.26722 14.7232 4.89072 14.7232 4.49022C14.7232 4.08972 14.5672 3.71322 14.2837 3.42972L13.0942 2.24022C12.8107 1.95672 12.4342 1.80072 12.0337 1.80072C11.6332 1.80072 11.2567 1.95672 10.974 2.23947L3 10.1887V13.5H6.30975L14.2837 5.55072ZM12.0337 3.30072L13.224 4.48947L12.0315 5.67747L10.842 4.48872L12.0337 3.30072ZM4.5 12V10.8112L9.78 5.54772L10.9695 6.73722L5.69025 12H4.5ZM3 15H15V16.5H3V15Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencil);
export default __webpack_public_path__ + "static/media/icon-edit-pencil.2c5b274251a10921d378a9b98c7162e9.svg";
export { ForwardRef as ReactComponent };